import { render, staticRenderFns } from "./CalizySelfcareLinksPopup.vue?vue&type=template&id=1337c3f6"
import script from "./CalizySelfcareLinksPopup.vue?vue&type=script&lang=ts"
export * from "./CalizySelfcareLinksPopup.vue?vue&type=script&lang=ts"
import style0 from "./CalizySelfcareLinksPopup.vue?vue&type=style&index=0&id=1337c3f6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports